import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/serviceBookingsSagas";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";

export const Dropdown = ({ keyName, label, width, skipLoader }) => {
  const dispatch = useDispatch();

  const isFiltersLoading = useSelector((state) => state.serviceBookings.isFiltersLoading);
  const options = useSelector((state) => state.serviceBookings.filters[keyName]);
  const selectedFilters = useSelector((state) => state.serviceBookings.selectedFilters[keyName]);

  const onOptionsChange = (data) => {
    dispatch(actionCreators.updateFilters({ data, key: keyName }));
  };

  return (
    <div className="select-box" style={{ width }}>
      <p className="offers-title">{label}</p>
      {isFiltersLoading && !skipLoader ? (
        <LoadingAnimation uiLoader />
      ) : (
        <MultiSelectDropdown
          options={options}
          enableOnly
          includeSelectAll
          includeFilter
          selectedFilters={selectedFilters}
          placeholder="Not Selected"
          numberDisplayed={0}
          onSelectChange={onOptionsChange}
        />
      )}
    </div>
  );
};
